export const formatCount = value => Number(value || 0).toLocaleString();

const COMPACT_COUNT_FORMATTER = new Intl.NumberFormat('en-US', { notation: 'compact' });

// Axis ticks, legend pills and badges get a few characters of room each, which a fleet of tens of
// thousands of devices runs straight out of. Anything past a thousand is abbreviated (1.2k, 34k,
// 1.1m) and the exact count is left to the tooltip.
export const formatCompactCount = value => {
  const count = Number(value || 0);

  return Math.abs(count) < 1000
    ? String(count)
    : COMPACT_COUNT_FORMATTER.format(count).toLowerCase();
};

export const formatTextNumber = text => {
  if (!text) return null;

  const sanitizedText = text.replace(/\D/g, '');
  return Number(sanitizedText);
};
